import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button } from '@material-ui/core';
import CancelButton from '../atoms/CancelButton';

const styles = {
  textBody: {
    color: 'red'
  }
};

const enhance = compose();

const Main = enhance(
  ({ classes, openDelete, updateOpenDelete, cancelAction, deleteAction }) => {
    return (
      <Dialog
        open={openDelete}
        onClose={() => {
          updateOpenDelete(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.textBody}
          >
            データを更新しますか？
            <br />
            一度「レシート登録不要」にすると
            <strong>元に戻せません</strong>
            ので、十分に確認した上で更新してください。
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClickAction={cancelAction} color="default" />
          <Button onClick={deleteAction} color="secondary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
